import { IS_NODE } from 'client/utils/environment';

export const UNINITIALIZED_CLIENT_CONFIG_ERROR =
  'CRITICAL SERVER ERROR: ClientConfig accessed before initialization, VENOM SERVER NOT STARTED!!!';

let config = {};
let isInitialized = false;

export const ClientConfig = {
  load(obj = {}) {
    config = {
      ...config,
      ...obj,
    };
    isInitialized = true;
    return this;
  },

  save(obj = {}) {
    return {
      ...obj,
      ...config,
    };
  },

  get(key, defaultValue) {
    if (IS_NODE && !isInitialized) {
      throw new Error(UNINITIALIZED_CLIENT_CONFIG_ERROR);
    }

    return config[key] || defaultValue;
  },

  /**
   * to be used only by platform team
   * @param key
   * @param val
   */
  set(key, val) {
    config[key] = val;
  },
};

// Whatever file accesses ClientConfig first and is on client side, load pre load
// pre load is always defined on client side
if (!IS_NODE) {
  // eslint-disable-next-line venom/no-prohibited-functions
  if (window.EDM?.preloadedState !== undefined) {
    ClientConfig.load(window.EDM.preloadedState.config); // eslint-disable-line venom/no-prohibited-functions
  } else if (window.EDM?.Venom?.clientConfig !== undefined) {
    ClientConfig.load(window.EDM?.Venom?.clientConfig);
  }
}
